import { ComponentType, lazy } from 'react';
import { PanelNotFound } from './dashboard/PanelNotFound';
import { PanelContainer } from './types';
import { ContainerNotFound } from './dashboard/ContainerNotFound';

const importedContainers: Record<string, PanelContainer> = {};
const importedPanels: Record<
  string,
  ComponentType<{ initialData: unknown }>
> = {};

export function importContainer(path: string): PanelContainer {
  if (!importedContainers[path])
    importedContainers[path] = lazy<PanelContainer>(() => {
      return new Promise<{
        default: PanelContainer;
      }>((resolve) => {
        import(
          /* webpackChunkName: "[request]" */
          /* webpackInclude: /\.tsx?$/ */
          /* webpackPreload: true */
          `/containers/${path}`
        )
          .then((result: { default: { default: PanelContainer } }) => {
            resolve(result.default);
          })
          .catch(() => {
            resolve({
              default: ContainerNotFound,
            });
          });
      });
    });

  return importedContainers[path];
}

export function importPanel(path: string) {
  if (!importedPanels[path])
    importedPanels[path] = lazy<ComponentType<{ initialData: unknown }>>(() => {
      return new Promise<{
        default: ComponentType<{ initialData: unknown }>;
      }>((resolve) => {
        import(
          /* webpackChunkName: "[request]" */
          /* webpackInclude: /\.tsx?$/ */
          /* webpackPreload: true */
          `/panels/${path}`
        )
          .then(
            (result: {
              default: { default: ComponentType<{ initialData: unknown }> };
            }) => {
              resolve(result.default);
            },
          )
          .catch(() => {
            resolve({
              default: PanelNotFound,
            });
          });
      });
    });

  return importedPanels[path];
}
